import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, LayersIcon, TargetIcon, TrendingUpIcon, CheckCircleIcon, SparklesIcon, ZapIcon, UsersIcon } from 'lucide-react';
export function GTMPlaybooksPage() {
  return <div className="w-full bg-white" data-id="element-6794">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-amber-900 via-orange-800 to-red-900 text-white py-24 overflow-hidden" data-id="element-6795">
        <div className="absolute inset-0 bg-grid-white/[0.05] bg-[size:20px_20px]" data-id="element-6796" />
        <div className="absolute inset-0" data-id="element-6797">
          <div className="absolute top-20 left-10 w-72 h-72 bg-amber-500/20 rounded-full blur-3xl animate-pulse" data-id="element-6798" />
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-red-500/20 rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-6799" />
        </div>
        <div className="max-w-7xl mx-auto px-6 relative" data-id="element-6800">
          <div className="max-w-4xl mx-auto text-center" data-id="element-6801">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-500/20 rounded-full border border-amber-400/30 mb-6" data-id="element-6802">
              <BookOpenIcon className="w-4 h-4" data-id="element-6803" />
              <span className="text-sm font-medium" data-id="element-6804">
                Complete GTM Strategies
              </span>
            </div>
            <h1 className="text-6xl font-bold mb-6 leading-tight" data-id="element-6805">
              GTM Playbooks
            </h1>
            <p className="text-xl text-amber-100 mb-8 leading-relaxed" data-id="element-6806">
              Complete, multi-play strategies for specific GTM motions.
              Playbooks orchestrate multiple plays into cohesive campaigns.
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-6807">
              <Link to="/signup" className="px-8 py-4 bg-white text-amber-900 rounded-lg hover:bg-amber-50 font-medium text-lg shadow-lg hover:shadow-xl transition-all" data-id="element-6808">
                Explore Playbooks
              </Link>
              <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-6809">
                Schedule Demo
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* What Playbooks Are */}
      <section className="py-24 bg-white" data-id="element-6810">
        <div className="max-w-7xl mx-auto px-6" data-id="element-6811">
          <div className="text-center mb-16" data-id="element-6812">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-6813">
              What GTM Playbooks are
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-6814">
              Playbooks are collections of coordinated plays that work together
              to achieve a specific GTM objective. They provide the full
              strategy, not just individual tactics.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-6815">
            <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl p-8 border-2 border-amber-200" data-id="element-6816">
              <div className="w-16 h-16 bg-amber-600 rounded-xl flex items-center justify-center mb-6" data-id="element-6817">
                <LayersIcon className="w-8 h-8 text-white" data-id="element-6818" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-6819">
                Multi-play coordination
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-6820">
                Orchestrate 5-10 plays that work together across the customer
                journey
              </p>
            </div>
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-8 border-2 border-orange-200" data-id="element-6821">
              <div className="w-16 h-16 bg-orange-600 rounded-xl flex items-center justify-center mb-6" data-id="element-6822">
                <TargetIcon className="w-8 h-8 text-white" data-id="element-6823" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-6824">
                Strategic objectives
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-6825">
                Designed for specific goals like new logo acquisition or
                expansion
              </p>
            </div>
            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-xl p-8 border-2 border-red-200" data-id="element-6826">
              <div className="w-16 h-16 bg-red-600 rounded-xl flex items-center justify-center mb-6" data-id="element-6827">
                <TrendingUpIcon className="w-8 h-8 text-white" data-id="element-6828" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-6829">
                Proven frameworks
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-6830">
                Based on best practices from high-performing GTM teams
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Playbooks */}
      <section className="py-24 bg-gray-50" data-id="element-6831">
        <div className="max-w-7xl mx-auto px-6" data-id="element-6832">
          <div className="text-center mb-16" data-id="element-6833">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-6834">
              Featured Playbooks
            </h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-6835">
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-6836">
              <div className="flex items-start justify-between mb-4" data-id="element-6837">
                <div data-id="element-6838">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-6839">
                    Intent-Based Engagement
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-6840">
                    7 plays • 21 days • ABM + Outbound
                  </p>
                </div>
                <span className="px-3 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full" data-id="element-6841">
                  Top Rated
                </span>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-6842">
                Detect buying signals across multiple channels and accelerate
                outreach to increase meeting conversion within defined
                timeframes.
              </p>
              <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-6843">
                <div className="p-3 bg-amber-50 rounded-lg" data-id="element-6844">
                  <p className="text-xs text-amber-700 mb-1" data-id="element-6845">Expected Lift</p>
                  <p className="text-sm font-semibold text-amber-900" data-id="element-6846">
                    +25-30%
                  </p>
                </div>
                <div className="p-3 bg-orange-50 rounded-lg" data-id="element-6847">
                  <p className="text-xs text-orange-700 mb-1" data-id="element-6848">Time to Value</p>
                  <p className="text-sm font-semibold text-orange-900" data-id="element-6849">
                    7-14 days
                  </p>
                </div>
                <div className="p-3 bg-red-50 rounded-lg" data-id="element-6850">
                  <p className="text-xs text-red-700 mb-1" data-id="element-6851">Activation</p>
                  <p className="text-sm font-semibold text-red-900" data-id="element-6852">78%</p>
                </div>
              </div>
              <div className="space-y-2 mb-4" data-id="element-6853">
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-6854">
                  <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-6855" />
                  <span data-id="element-6856">High-Intent Account Blitz</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-6857">
                  <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-6858" />
                  <span data-id="element-6859">Buying Group Gap Fill</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-6860">
                  <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-6861" />
                  <span data-id="element-6862">Predictive Priority Routing</span>
                </div>
              </div>
              <div className="flex flex-wrap gap-2" data-id="element-6863">
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-6864">
                  Signal-First
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-6865">
                  Agent-Ready
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-6866">
                  ABM
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-6867">
              <div className="flex items-start justify-between mb-4" data-id="element-6868">
                <div data-id="element-6869">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-6870">
                    Product-Led Expansion
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-6871">
                    5 plays • 30 days • PLG + CS
                  </p>
                </div>
                <span className="px-3 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded-full" data-id="element-6872">
                  High Impact
                </span>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-6873">
                Use usage patterns and firmographic fit to trigger cross-sell
                and upsell motions through automated workflows.
              </p>
              <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-6874">
                <div className="p-3 bg-amber-50 rounded-lg" data-id="element-6875">
                  <p className="text-xs text-amber-700 mb-1" data-id="element-6876">Expected Lift</p>
                  <p className="text-sm font-semibold text-amber-900" data-id="element-6877">
                    +30-35%
                  </p>
                </div>
                <div className="p-3 bg-orange-50 rounded-lg" data-id="element-6878">
                  <p className="text-xs text-orange-700 mb-1" data-id="element-6879">Time to Value</p>
                  <p className="text-sm font-semibold text-orange-900" data-id="element-6880">
                    21-30 days
                  </p>
                </div>
                <div className="p-3 bg-red-50 rounded-lg" data-id="element-6881">
                  <p className="text-xs text-red-700 mb-1" data-id="element-6882">Activation</p>
                  <p className="text-sm font-semibold text-red-900" data-id="element-6883">88%</p>
                </div>
              </div>
              <div className="space-y-2 mb-4" data-id="element-6884">
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-6885">
                  <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-6886" />
                  <span data-id="element-6887">Product-Led to Sales Assist</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-6888">
                  <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-6889" />
                  <span data-id="element-6890">AI Products Expansion</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-6891">
                  <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-6892" />
                  <span data-id="element-6893">Usage-Based Expansion</span>
                </div>
              </div>
              <div className="flex flex-wrap gap-2" data-id="element-6894">
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-6895">
                  PLG
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-6896">
                  Agent-Ready
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-6897">
                  Expansion
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-6898">
              <div className="flex items-start justify-between mb-4" data-id="element-6899">
                <div data-id="element-6900">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-6901">
                    Event-Driven Pipeline
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-6902">
                    4 plays • 45 days • Event + ABM
                  </p>
                </div>
                <span className="px-3 py-1 bg-purple-100 text-purple-700 text-xs font-medium rounded-full" data-id="element-6903">
                  Seasonal
                </span>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-6904">
                Orchestrate pre-event targeting, real-time engagement, and
                post-event follow-up to convert attendees into qualified
                pipeline.
              </p>
              <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-6905">
                <div className="p-3 bg-amber-50 rounded-lg" data-id="element-6906">
                  <p className="text-xs text-amber-700 mb-1" data-id="element-6907">Expected Lift</p>
                  <p className="text-sm font-semibold text-amber-900" data-id="element-6908">
                    +35-40%
                  </p>
                </div>
                <div className="p-3 bg-orange-50 rounded-lg" data-id="element-6909">
                  <p className="text-xs text-orange-700 mb-1" data-id="element-6910">Time to Value</p>
                  <p className="text-sm font-semibold text-orange-900" data-id="element-6911">
                    30-45 days
                  </p>
                </div>
                <div className="p-3 bg-red-50 rounded-lg" data-id="element-6912">
                  <p className="text-xs text-red-700 mb-1" data-id="element-6913">Activation</p>
                  <p className="text-sm font-semibold text-red-900" data-id="element-6914">82%</p>
                </div>
              </div>
              <div className="space-y-2 mb-4" data-id="element-6915">
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-6916">
                  <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-6917" />
                  <span data-id="element-6918">Event Echo Campaign</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-6919">
                  <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-6920" />
                  <span data-id="element-6921">High-Value Content Syndication</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-6922">
                  <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-6923" />
                  <span data-id="element-6924">Account Warming Programs</span>
                </div>
              </div>
              <div className="flex flex-wrap gap-2" data-id="element-6925">
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-6926">
                  Event
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-6927">
                  Agent-Ready
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-6928">
                  ABM
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-6929">
              <div className="flex items-start justify-between mb-4" data-id="element-6930">
                <div data-id="element-6931">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-6932">
                    Opportunity Re-Engagement
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-6933">
                    3 plays • 30 days • ABM
                  </p>
                </div>
                <span className="px-3 py-1 bg-orange-100 text-orange-700 text-xs font-medium rounded-full" data-id="element-6934">
                  Deal Rescue
                </span>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-6935">
                Identify dormant deals and gaps in buying committee coverage,
                then deploy targeted campaigns to revive stalled pipeline.
              </p>
              <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-6936">
                <div className="p-3 bg-amber-50 rounded-lg" data-id="element-6937">
                  <p className="text-xs text-amber-700 mb-1" data-id="element-6938">Expected Lift</p>
                  <p className="text-sm font-semibold text-amber-900" data-id="element-6939">
                    +15-20%
                  </p>
                </div>
                <div className="p-3 bg-orange-50 rounded-lg" data-id="element-6940">
                  <p className="text-xs text-orange-700 mb-1" data-id="element-6941">Time to Value</p>
                  <p className="text-sm font-semibold text-orange-900" data-id="element-6942">
                    14-21 days
                  </p>
                </div>
                <div className="p-3 bg-red-50 rounded-lg" data-id="element-6943">
                  <p className="text-xs text-red-700 mb-1" data-id="element-6944">Activation</p>
                  <p className="text-sm font-semibold text-red-900" data-id="element-6945">65%</p>
                </div>
              </div>
              <div className="space-y-2 mb-4" data-id="element-6946">
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-6947">
                  <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-6948" />
                  <span data-id="element-6949">Buying Group Gap Fill</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-6950">
                  <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-6951" />
                  <span data-id="element-6952">Champion Activation</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-6953">
                  <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-6954" />
                  <span data-id="element-6955">Competitive Displacement</span>
                </div>
              </div>
              <div className="flex flex-wrap gap-2" data-id="element-6956">
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-6957">
                  Agent-Ready
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-6958">
                  ABM
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-6959">
                  Deal Acceleration
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Playbook vs Play */}
      <section className="py-24 bg-white" data-id="element-6960">
        <div className="max-w-7xl mx-auto px-6" data-id="element-6961">
          <div className="text-center mb-16" data-id="element-6962">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-6963">
              Playbook vs Play: What's the difference?
            </h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-6964">
            <div className="bg-gradient-to-br from-violet-50 to-violet-100 rounded-xl p-8 border-2 border-violet-200" data-id="element-6965">
              <div className="flex items-center gap-3 mb-6" data-id="element-6966">
                <div className="w-12 h-12 bg-violet-600 rounded-lg flex items-center justify-center" data-id="element-6967">
                  <LayersIcon className="w-6 h-6 text-white" data-id="element-6968" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-6969">Playbook</h3>
              </div>
              <ul className="space-y-3" data-id="element-6970">
                <li className="flex items-start gap-2" data-id="element-6971">
                  <CheckCircleIcon className="w-5 h-5 text-violet-600 flex-shrink-0 mt-0.5" data-id="element-6972" />
                  <span className="text-gray-700" data-id="element-6973">
                    Complete multi-play strategy
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-6974">
                  <CheckCircleIcon className="w-5 h-5 text-violet-600 flex-shrink-0 mt-0.5" data-id="element-6975" />
                  <span className="text-gray-700" data-id="element-6976">
                    Covers full customer journey
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-6977">
                  <CheckCircleIcon className="w-5 h-5 text-violet-600 flex-shrink-0 mt-0.5" data-id="element-6978" />
                  <span className="text-gray-700" data-id="element-6979">5-10 coordinated plays</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-6980">
                  <CheckCircleIcon className="w-5 h-5 text-violet-600 flex-shrink-0 mt-0.5" data-id="element-6981" />
                  <span className="text-gray-700" data-id="element-6982">
                    Strategic objective (e.g., new logo acquisition)
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-6983">
                  <CheckCircleIcon className="w-5 h-5 text-violet-600 flex-shrink-0 mt-0.5" data-id="element-6984" />
                  <span className="text-gray-700" data-id="element-6985">30-90 day timeframe</span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl p-8 border-2 border-amber-200" data-id="element-6986">
              <div className="flex items-center gap-3 mb-6" data-id="element-6987">
                <div className="w-12 h-12 bg-amber-600 rounded-lg flex items-center justify-center" data-id="element-6988">
                  <ZapIcon className="w-6 h-6 text-white" data-id="element-6989" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-6990">Play</h3>
              </div>
              <ul className="space-y-3" data-id="element-6991">
                <li className="flex items-start gap-2" data-id="element-6992">
                  <CheckCircleIcon className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-6993" />
                  <span className="text-gray-700" data-id="element-6994">Single, focused tactic</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-6995">
                  <CheckCircleIcon className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-6996" />
                  <span className="text-gray-700" data-id="element-6997">
                    Specific trigger and workflow
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-6998">
                  <CheckCircleIcon className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-6999" />
                  <span className="text-gray-700" data-id="element-7000">4-8 touchpoints</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-7001">
                  <CheckCircleIcon className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-7002" />
                  <span className="text-gray-700" data-id="element-7003">
                    Tactical goal (e.g., book meeting)
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-7004">
                  <CheckCircleIcon className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-7005" />
                  <span className="text-gray-700" data-id="element-7006">7-21 day timeframe</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-amber-600 to-red-700 text-white" data-id="element-7007">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-7008">
          <h2 className="text-4xl font-bold mb-6" data-id="element-7009">
            Ready to deploy complete GTM strategies?
          </h2>
          <p className="text-xl text-amber-100 mb-8" data-id="element-7010">
            Explore proven playbooks and start orchestrating multi-play
            campaigns
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-7011">
            <Link to="/signup" className="px-8 py-4 bg-white text-amber-600 rounded-lg hover:bg-amber-50 font-medium text-lg shadow-lg" data-id="element-7012">
              Explore Playbooks
            </Link>
            <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-7013">
              Talk to Sales
            </Link>
          </div>
        </div>
      </section>
    </div>;
}